import translationKeys from '@translationKeys'

export default {
  [translationKeys.FETCHING_ERROR]: 'Error while fetching profile data',
  [translationKeys.PROFILE_SECTION_EMPTY]: 'No details have been added to this profile yet',
  [translationKeys.COMPANY_PROFILE_SECTION_SUMMARY]: 'Company summary',
  [translationKeys.COMPANY_PROFILE_SECTION_PRODUCTS]: 'Summary Products / Services / Technologies',
  [translationKeys.COMPANY_PROFILE_SECTION_COLLABORATIONS]: 'Collaborations and clients',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_STRATEGY]: 'Partnering strategy / collaborations',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_CLIENT_PORTFOLIO]: 'Client portfolio',
  [translationKeys.COMPANY_PROFILE_SECTION_ADDITIONAL_INFO]: 'Additional information',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_HIGHLIGHTS]: 'Corporate Highlights',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_ANTICIPATED_HIGHLIGHTS]: 'Anticipated Corporate Highlights',
  [translationKeys.COMPANY_PROFILE_SECTION_ATTACHMENTS]: 'Attachments',
  [translationKeys.COMPANY_PROFILE_SECTION_CATEGORIZATION]: 'Categorization',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_MAIN_SECTOR]: 'Main sector',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_SUBSECTORS]: 'Subsector(s)',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_TERAPEUTIC_AREA]: 'Primary therapeutic area(s)',
  [translationKeys.COMPANY_PROFILE_SECTION_COMPANY_DATA]: 'Company data',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_EMPLOYEES]: 'Employees (worldwide)',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_PHDS_NUMBER]: 'Number of PhDs',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_FOUNDED_YEAR]: 'Founded (year)',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_FOUNDATION_SOURCE]: 'Source of foundation',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_OWNERSHIP_STATE]: 'State of ownership',
  [translationKeys.COMPANY_PROFILE_SECTION_CONTACTS]: 'Contact details',
  [translationKeys.COMPANY_PROFILE_SECTION_INVESTMENT]: 'Investment',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_INVESTMENT_TIMEFRAME]: 'Investment timeframe',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_INVESTMENT_STAGE]: 'Investment stage',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_TICKER_SYMBOL]: 'Primary ticker symbol',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_STOCK_EXCHANGE]: 'Primary stock exchange',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_SECONDARY_LISTINGS]: 'Secondary listings',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_IPO]: 'IPO (year)',
  [translationKeys.COMPANY_PROFILE_SUBSECTION_ADDITIONAL_LISTING_INFO]: 'Additional information on listings',
  [translationKeys.COMPANY_CARD_OVERVIEW]: 'Company overview',
  [translationKeys.COMPANY_CARD_SUMMARY]: 'Company summary',
  [translationKeys.COMPANY_CARD_MAIN_SECTOR]: 'Main sector',
  [translationKeys.COMPANY_CARD_SUBSECTOR]: 'Subsector(s)',
  [translationKeys.COMPANY_CARD_THERAPEUTIC_AREA]: 'Primary therapeutic area(s)',
  [translationKeys.COMPANY_CARD_CONTACT_DETAILS]: 'Contact Details',
  [translationKeys.COMPANY_CARD_PROFILE_BUTTON]: 'See the full company profile',
  [translationKeys.ASSET_PRODUCT_DESCRIPTION]: 'Product description',
  [translationKeys.ASSET_FIELD_OF_USE_RESTRICTIONS]: 'Field of use restriction',
  [translationKeys.ASSET_CLINICAL_STRATEGY]: 'Clinical trials/clinical strategy',
  [translationKeys.ASSET_KEY_PUBLICATIONS]: 'Key publications',
  [translationKeys.ASSET_IP_RIGHTS]: 'IP rights',
  [translationKeys.ASSET_PARTNERS]: 'Partners',
  [translationKeys.ASSET_URL]: 'URL',
  [translationKeys.ASSET_ATTACHMENTS]: 'Attachments',
  [translationKeys.ASSET_MAIN_THERAPEUTIC_SECTOR]: 'Main therapeutic sector (based on ICD-10 codes)',
  [translationKeys.ASSET_THERAPEUTIC_SUBSECTOR]: 'Therapeutic subsector',
  [translationKeys.ASSET_MOLECULE_TYPE]: 'Molecule type',
  [translationKeys.ASSET_MODE_OF_ADMINISTRATION]: 'Mode of administration',
  [translationKeys.ASSET_PRIMARY_MARKET]: 'Primary market',
  [translationKeys.ASSET_SERVICE_DESCRIPTION]: 'Service description',
  [translationKeys.ASSET_SERVICE_CATEGORY]: 'Service category',
  [translationKeys.ASSET_SUBCATEGORIES]: 'Subcategories',
  [translationKeys.ASSET_SERVICE_STATUS]: 'Service status',
  [translationKeys.ASSET_SERVICE_AVAILABILITY]: 'Service availability',
  [translationKeys.ASSET_TECHNOLOGY_DESCRIPTION]: 'Technology description',
  [translationKeys.ASSET_CATEGORIZATION]: 'Categorization',
  [translationKeys.ASSET_SECTOR]: 'Sector',
  [translationKeys.ASSET_SUBSECTOR]: 'Subsector(s)​',
  [translationKeys.ASSET_ORPHAN_DISEASE_INDICATION]: 'Orphan disease indication',
  [translationKeys.ASSET_DEVELOPMENT_PHASE]: 'Development phase',
  [translationKeys.ASSET_PARTNERING_STATUS]: 'Partnering status',
  [translationKeys.ASSET_MARKETING_RIGHTS]: 'Marketing rights available/sought',
  [translationKeys.DELEGATE_PROFILE_SECTION_PARTNERING_OBJECTIVES]: 'Partnering objectives',
  [translationKeys.DELEGATE_PROFILE_SECTION_PROF_BACKGROUND]: 'Professional Background',
  [translationKeys.DELEGATE_PROFILE_SECTION_EXPERTISE_AREA]: 'Primary area of expertise',
  [translationKeys.DELEGATE_PROFILE_SECTION_AFFILIATIONS]: 'Current and previous affiliations',
  [translationKeys.DELEGATE_PROFILE_SECTION_DEALS]: 'Deals you have been involved in',
  [translationKeys.DELEGATE_PROFILE_SECTION_ATTACHMENTS]: 'Attachments',
  [translationKeys.DELEGATE_PROFILE_SECTION_SHARED_CONTACT_INFO]: 'Shared Contact Information',
  [translationKeys.DELEGATE_PROFILE_SECTION_SHARED_CONTACT_PHONE]: 'Phone number',
  [translationKeys.DELEGATE_PROFILE_SECTION_SHARED_CONTACT_EMAIL]: 'Email address',
  [translationKeys.DELEGATE_PROFILE_SECTION_MAIN_INFO]: 'Main information',
  [translationKeys.DELEGATE_PROFILE_SUBSECTION_ADDRESS]: 'Address',
  [translationKeys.DELEGATE_PROFILE_SUBSECTION_WEBSITE]: 'Website',
  [translationKeys.LATEST_ASSETS_TITLE]: 'Latest products and services',
  [translationKeys.LATEST_ASSETS_BIO_TAB]: 'Biotech/Pharma Products ({{count}})',
  [translationKeys.LATEST_ASSETS_MED_TAB]: 'Medtech ({{count}})',
  [translationKeys.LATEST_ASSETS_SERVICE_TAB]: 'Services ({{count}})',
  [translationKeys.LATEST_ASSETS_TECH_TAB]: 'Technologies ({{count}})',
  [translationKeys.LATEST_ASSETS_SELL_ALL_BUTTON]: 'See all products',
  [translationKeys.PROFILES_BREADCRUMBDS_ALL_PRODUCTS]: 'All products',
  [translationKeys.PROFILES_BREADCRUMBDS_COMPANY_PROFILE]: 'Company Profile',
  [translationKeys.PROFILES_BREADCRUMBDS_LATEST_COMPANY_PRODUCTS]: 'Latest company products',
  [translationKeys.PROFILES_BREADCRUMBDS_ALL_DELEGATES]: 'All delegates',
  [translationKeys.ALL_PRODUCT_AND_SERVICES_TITLE]: 'All products and services',
  [translationKeys.ALL_PRODUCTS_FILTER_BY_EVENT_LABEL]: 'Filter by event',
  [translationKeys.ALL_PRODUCTS_FILTER_BY_MOLECULE_LABEL]: 'Filter by molecule type',
  [translationKeys.ALL_PRODUCTS_FILTER_BY_PHASE_LABEL]: 'Filter by phase',
  [translationKeys.ALL_PRODUCTS_FILTER_BY_THERAPEUTIC_LABEL]: 'Filter by therapeutic area',
  [translationKeys.ALL_PRODUCTS_EMPTY_ASSETS_MESSAGE]: 'There are no assets for the event',
  [translationKeys.ATTENDEES_TITLE]: 'Attendees at last event',
  [`${translationKeys.NEW_MESSAGES}_other`]: '{{count}} new messages',
  [`${translationKeys.NEW_MESSAGES}_one`]: '{{count}} new message',
  [translationKeys.INBOX_TITLE]: 'Inbox',
  [translationKeys.ONE_MAIL_PROMPT]: 'Reach out all year round with Contact',
  [translationKeys.FILTER_BY_MOST_RECENT]: 'Filter by most recent',
  [translationKeys.CLICK_HERE_TO_SUBSCRIBE]: 'Click here to subscribe',
  [translationKeys.CLICK_HERE_TO_UPGRADE]: 'Click here to upgrade',
  [translationKeys.INBOX]: 'Inbox',
  [translationKeys.ATTENDEES_AT]: 'Attendees at:',
  [translationKeys.MOST_RECENT]: 'Most recent',
  [translationKeys.MOST_UNREAD]: 'Unread',
  [translationKeys.MENU_DELETE]: 'Delete',
  [translationKeys.MENU_UNREAD]: 'Mark as unread',
  [translationKeys.MENU_PROFILE]: 'Go to profile',
  [translationKeys.SORT_BY]: 'Sort by',
  [translationKeys.PROFILE_EVENTS]: 'Events',
  [translationKeys.PROFILE_CURRENT_EVENTS]: '{{name}} is attending',
  [translationKeys.PROFILE_PAST_EVENTS]: 'Past events',
  [translationKeys.VIEW_MORE_EVENTS]: 'View more events',
}
